import React from "react";
import { CheckCircle, Star, BookOpen, Award, Trophy, GraduationCap } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const benefits = [
  { icon: BookOpen, text: "Acesso a todas as trilhas de carreira" },
  { icon: Star, text: "Lives semanais com especialistas" },
  { icon: Award, text: "Certificações reconhecidas pelo Portal Portüs" },
  { icon: Trophy, text: "Participe do ranking público" },
  { icon: CheckCircle, text: "Provas e avaliações ilimitadas" },
  { icon: GraduationCap, text: "Score visível para recrutadores" },
];

export default function Subscription() {
  return (
    <div className="max-w-3xl mx-auto space-y-8">
      <div className="text-center">
        <div className="w-14 h-14 rounded-2xl flex items-center justify-center mx-auto mb-4"
          style={{ background: '#00DCA4' }}>
          <GraduationCap className="w-7 h-7" style={{ color: '#003326' }} />
        </div>
        <h1 className="text-4xl font-bold" style={{ fontFamily: 'Poppins, sans-serif', color: '#003326' }}>
          Portus Talent Pro
        </h1>
        <p className="mt-2" style={{ color: '#646C6F' }}>
          Invista no seu desenvolvimento e destaque-se no mercado da nova economia.
        </p>
      </div>

      <div className="grid sm:grid-cols-2 gap-4">
        {/* Monthly */}
        <Card className="shadow-sm" style={{ border: '2px solid #E5E9EA' }}>
          <CardContent className="p-6">
            <p className="font-semibold mb-1" style={{ color: '#646C6F' }}>Mensal</p>
            <p className="text-4xl font-bold" style={{ fontFamily: 'Poppins, sans-serif', color: '#2E3233' }}>
              R$79
            </p>
            <p className="text-sm mt-0.5" style={{ color: '#99A6AB' }}>/mês</p>
            <button
              className="w-full mt-6 py-3 text-sm font-bold transition-opacity hover:opacity-90"
              style={{ background: '#00DCA4', color: '#003326', borderRadius: '100px' }}>
              Assinar Mensal
            </button>
          </CardContent>
        </Card>

        {/* Annual */}
        <Card className="shadow-md relative" style={{ border: '2px solid #00DCA4' }}>
          <div className="absolute -top-3 left-1/2 -translate-x-1/2">
            <span className="text-xs font-bold px-3 py-1 rounded-full"
              style={{ background: '#00DCA4', color: '#003326' }}>
              Mais popular
            </span>
          </div>
          <CardContent className="p-6">
            <p className="font-semibold mb-1" style={{ color: '#646C6F' }}>Anual</p>
            <p className="text-4xl font-bold" style={{ fontFamily: 'Poppins, sans-serif', color: '#2E3233' }}>
              R$59
            </p>
            <p className="text-sm mt-0.5" style={{ color: '#99A6AB' }}>/mês · cobrado anualmente</p>
            <p className="text-sm font-medium mt-1" style={{ color: '#00664C' }}>
              Economia de R$240/ano
            </p>
            <button
              className="w-full mt-4 py-3 text-sm font-bold transition-opacity hover:opacity-90"
              style={{ background: '#00DCA4', color: '#003326', borderRadius: '100px' }}>
              Assinar Anual
            </button>
          </CardContent>
        </Card>
      </div>

      {/* Benefits */}
      <Card className="border-0 shadow-sm">
        <CardContent className="p-6">
          <h3 className="font-semibold mb-4" style={{ color: '#2E3233' }}>O que está incluído</h3>
          <div className="grid sm:grid-cols-2 gap-3">
            {benefits.map((b, i) => (
              <div key={i} className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-xl flex items-center justify-center flex-shrink-0"
                  style={{ background: '#EAFAF6' }}>
                  <b.icon className="w-4 h-4" style={{ color: '#00664C' }} />
                </div>
                <p className="text-sm" style={{ color: '#2E3233' }}>{b.text}</p>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>

      <p className="text-center text-xs" style={{ color: '#99A6AB' }}>
        Pagamento processado com segurança via Stripe. Cancele a qualquer momento.
      </p>
    </div>
  );
}
